import { render, staticRenderFns } from "./StudentFilterBox.vue?vue&type=template&id=96bfcf90"
import script from "./StudentFilterBox.vue?vue&type=script&lang=js"
export * from "./StudentFilterBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports